// Staff Lead Generator feedback hooks. The post mutation invalidates the
// `leadGenFeedbackKeys.all` prefix so the detail feed refetches.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { leadGenFeedbackApi, type PostLeadGenFeedbackRequest } from "@/api/leadGen/feedback";
import { leadGenFeedbackKeys } from "@/hooks/leadGen/feedbackKeys";

export function useLeadGenFeedback(generatorId: string) {
  return useQuery({
    queryKey: leadGenFeedbackKeys.list(generatorId),
    queryFn: () => leadGenFeedbackApi.list(generatorId),
    enabled: !!generatorId,
  });
}

export function usePostLeadGenFeedback(generatorId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: PostLeadGenFeedbackRequest) => leadGenFeedbackApi.post(generatorId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadGenFeedbackKeys.all });
    },
  });
}
